import PropTypes from 'prop-types';
import React from 'react';
import { getClasses } from './RCUIButton';

const RCUIButtonLink = ({ type = '', size = '', classNames = '', children, ariaLabel, href, onClick }) => (
  <a
    aria-label={ariaLabel}
    className={getClasses(type, size, classNames)}
    href={href}
    onClick={onClick}
  >
    {children}
  </a>
);

RCUIButtonLink.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.any,
  classNames: PropTypes.string,
  ariaLabel: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default RCUIButtonLink;
